(function() {
  'use strict';

  const PRODUCTION_MODE = false; // debug konsol logları AÇIK ([Cart Set] ...); kullanıcı isteğiyle geri açıldı
  let productCache = {};
  let setGroups = new Map();
  let isUpdating = false;

  // ===== i18n / Çoklu dil desteği =====
  const I18N_STRINGS = {
    tr: {
      setDeleted: '{setType} set tamamen silindi: {title}',
      setDeleteError: 'Set silinirken bir hata oluştu',
      stockLimitedAdjusted: '{title}: Stok yetersiz, {sets} sete ayarlandı. {factor}',
      quantitiesCorrected: '{title}: Miktarlar düzeltildi ({sets} set: {items})',
      stockLimitedMax: 'Stok yetersiz! Maksimum {sets} set. {factor}',
      setAdded: '+{qty} adet (1 set) eklendi',
      setRemoved: '-{qty} adet (1 set) çıkarıldı',
      setTypeMulti: 'Çoklu beden',
      setTypeSingle: 'Tek beden',
      totalLabel: 'Toplam:',
      pieceUnit: 'adet'
    },
    ro: {
      setDeleted: 'Setul {setType} a fost complet șters: {title}',
      setDeleteError: 'A apărut o eroare la ștergerea setului',
      stockLimitedAdjusted: '{title}: Stoc limitat, ajustat la {sets} set. {factor}',
      quantitiesCorrected: '{title}: Cantitățile au fost corectate ({sets} set: {items})',
      stockLimitedMax: 'Stoc limitat! Maximum {sets} set. {factor}',
      setAdded: '+{qty} buc. (1 set) adăugat',
      setRemoved: '-{qty} buc. (1 set) eliminat',
      setTypeMulti: 'Multi-size',
      setTypeSingle: 'Single',
      totalLabel: 'Total:',
      pieceUnit: 'buc.'
    },
    en: {
      setDeleted: '{setType} set completely removed: {title}',
      setDeleteError: 'An error occurred while removing the set',
      stockLimitedAdjusted: '{title}: Insufficient stock, adjusted to {sets} sets. {factor}',
      quantitiesCorrected: '{title}: Quantities corrected ({sets} sets: {items})',
      stockLimitedMax: 'Insufficient stock! Maximum {sets} sets. {factor}',
      setAdded: '+{qty} pcs (1 set) added',
      setRemoved: '-{qty} pcs (1 set) removed',
      setTypeMulti: 'Multi-size',
      setTypeSingle: 'Single size',
      totalLabel: 'Total:',
      pieceUnit: 'pcs'
    }
  };

  function getCurrentLocale() {
    // 1. document.documentElement.lang (en, ro, tr vs.)
    const htmlLang = (document.documentElement.lang || '').toLowerCase().slice(0, 2);
    if (I18N_STRINGS[htmlLang]) return htmlLang;

    // 2. URL prefix (yakupstore.com/ro-ro/, /tr-ro/)
    const path = (window.location && window.location.pathname) || '';
    const urlMatch = path.match(/^\/([a-z]{2})(?:-[a-z]{2})?\//i);
    if (urlMatch) {
      const urlLang = urlMatch[1].toLowerCase();
      if (I18N_STRINGS[urlLang]) return urlLang;
    }

    // 3. Shopify global
    if (window.Shopify && window.Shopify.locale) {
      const shopLang = window.Shopify.locale.toString().toLowerCase().slice(0, 2);
      if (I18N_STRINGS[shopLang]) return shopLang;
    }

    return 'tr';
  }

  function t(key, vars) {
    const locale = getCurrentLocale();
    const dict = I18N_STRINGS[locale] || I18N_STRINGS.tr;
    let str = dict[key];
    if (str === undefined) str = (I18N_STRINGS.tr[key] !== undefined) ? I18N_STRINGS.tr[key] : key;
    if (vars) {
      for (const k in vars) {
        str = str.split('{' + k + '}').join(vars[k]);
      }
    }
    return str;
  }

  function log(...args) {
    if (!PRODUCTION_MODE) {
      console.log('[Cart Set]', ...args);
    }
  }

  // Beden ismini normalize et: trim, uppercase, sondaki nokta/boşluğu sil
  // (Romence çevirilerde "S.", "M." gibi noktayla biten değerlerle baş etmek için)
  function normalizeSize(size) {
    if (size === null || size === undefined) return '';
    return size.toString().toUpperCase().trim().replace(/[.\s]+$/, '');
  }
  
  // Kapsamlı set bilgisi parse fonksiyonu (quantity-multiplier.js'den uyarlanmış)
  function parseCompleteSetInfo(description, productTitle) {
    if (!description) return null;

    // DEBUG: Ham description'ı logla
    log('RAW DESCRIPTION:', description.substring(0, 500));

    let cleanText = description.toString().trim();
    cleanText = cleanText.replace(/<[^>]*>/g, ' ');
    cleanText = cleanText.replace(/&[a-zA-Z0-9#]+;/g, '');
    cleanText = cleanText.replace(/^\*+/g, '');
    cleanText = cleanText.replace(/\*+$/g, '');
    cleanText = cleanText.replace(/\*/g, '');
    cleanText = cleanText.replace(/[\r\n\t\f\v]/g, ' ');
    cleanText = cleanText.replace(/\s+/g, ' ');
    cleanText = cleanText.trim();

    // Romence -> Türkçe etiket normalizasyonu (çok dilli destek)
    cleanText = cleanText
      .replace(/Conținutul setului:/g, 'Set İçerik Bilgisi:')
      .replace(/Continutul setului:/g, 'Set İçerik Bilgisi:')
      .replace(/Setul de mărimi:/g, 'Beden Seti:')
      .replace(/Setul de marimi:/g, 'Beden Seti:')
      .replace(/Distribuție:/g, 'Dağılım:')
      .replace(/Distribuția:/g, 'Dağılım:')
      .replace(/Distributie:/g, 'Dağılım:')
      .replace(/Distributia:/g, 'Dağılım:');

    log('CLEAN TEXT:', cleanText.substring(0, 500));
    
    // 1. BEDEN SETİ FORMATI
    if (cleanText.includes('Beden Seti:') && cleanText.includes('Dağılım:')) {
      const variantDistributions = {};
      const sections = cleanText.split('Beden Seti:');
      
      for (let i = 1; i < sections.length; i++) {
        const section = sections[i];
        const dagitimParts = section.split('Dağılım:');
        
        if (dagitimParts.length > 1) {
          const bedenRange = dagitimParts[0].replace(/[()]/g, '').trim();
          const dagitimContent = dagitimParts[1].split(/Barkod|Teknik|$/)[0].trim();
          
          let totalQty = 0;
          const sizeMap = {};
          
          // XS:1 - S:1 - M:1 - L:1 formatını parse et
          const matches = dagitimContent.matchAll(/([A-Z]{1,3}):(\d+)/g);
          for (const match of matches) {
            const size = match[1];
            const qty = parseInt(match[2]);
            sizeMap[size] = qty;
            totalQty += qty;
          }
          
          if (totalQty > 0) {
            variantDistributions[bedenRange] = {
              total: totalQty,
              sizes: sizeMap
            };
          }
        }
      }
      
      if (Object.keys(variantDistributions).length > 0) {
        // Her range için toplam miktarı hesapla
        const totalPerRange = {};
        for (const [range, info] of Object.entries(variantDistributions)) {
          totalPerRange[range] = info.total;
        }

        log('Beden Seti formatı:', variantDistributions);
        return {
          type: 'beden_seti',
          distributions: variantDistributions,
          isMultiSize: true,
          totalPerRange: totalPerRange
        };
      }
    }
    
    // 2. SET İÇERİK BİLGİSİ FORMATI (S-2 M-2 L-2 veya 2S-2M-2L)
    let setContent = null;
    
    if (cleanText.includes('Set İçerik Bilgisi:')) {
      const parts = cleanText.split('Set İçerik Bilgisi:');
      if (parts.length > 1) {
        const endMarkers = [
          // Türkçe
          'Teknik', 'Kumaş', 'Kalıp', 'Kol', 'Beden', 'Bakım', 'Ürün', 'Barkod', 'Model',
          'Marka', 'Renk', 'Manken', 'Yıkama', 'Fotoğraf',
          // English
          'Product', 'Features', 'Material', 'Care',
          // Romence
          'Caracteristici', 'Materiale', 'Material', 'Croială', 'Croiala', 'Mânecă', 'Maneca',
          'Mărime', 'Marime', 'Întreținere', 'Intretinere', 'Produs', 'Țesătură', 'Tesatura'
        ];
        let content = parts[1];

        // En erken görünen marker'ı bul ve oradan kes
        // (Önemli: for-loop break yerine earliest-index aramak gerekiyor,
        //  yoksa listenin ilk match'inde durup sonraki gerçek end-marker'ı kaçırıyor
        //  ve "Ürün Kodu : 97313-04" set content'e sızıp "313:4" gibi yanlış
        //  beden parse'ına sebep oluyor)
        let earliestIndex = -1;
        for (const marker of endMarkers) {
          const idx = content.indexOf(marker);
          if (idx !== -1 && (earliestIndex === -1 || idx < earliestIndex)) {
            earliestIndex = idx;
          }
        }
        if (earliestIndex !== -1) {
          content = content.substring(0, earliestIndex);
        }
        setContent = content.trim();
      }
    }

    // 3. DAĞILIM FORMATI
    if (!setContent && cleanText.includes('Dağılım:')) {
      const parts = cleanText.split('Dağılım:');
      if (parts.length > 1) {
        setContent = parts[1].split(/Teknik|Kumaş|Kalıp|Kol|Bakım|Barkod|Product|Features|Material|Caracteristici|Materiale|Croială|Croiala|Mânecă|Maneca|Mărime|Marime|Întreținere|Intretinere|Produs|Țesătură|Tesatura/)[0].trim();
      }
    }

    // DEBUG: Set içeriğini logla
    if (setContent) {
      log('SET CONTENT (RAW):', JSON.stringify(setContent));
      log('SET CONTENT (length):', setContent.length);
    }

    // Set içeriğini parse et
    if (setContent) {
      const distribution = {};
      let hasMultipleSizes = false;

      // Geçerli beden isimleri - quantity-multiplier.js ile uyumlu
      const excludedWords = new Set(['TRY', 'USD', 'EUR', 'GBP', 'ADET', 'KG', 'TL', 'MAL', 'VE', 'BR', 'DIV', 'EM', 'TEK']);
      const validSizes = new Set(['S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XS', '2XL', '3XL', '4XL', '5XL', '6XL']);

      // YENİ: Parantez formatı - "(S-M)-3" veya "(S-M):3"
      const parenthesisPattern = /\(([A-Z]+(?:-[A-Z]+)*)\)\s*[-:=]\s*(\d+)/gi;
      const parenthesisMatches = [...setContent.matchAll(parenthesisPattern)];

      if (parenthesisMatches.length > 0) {
        log('Parenthesis format detected in cart parser');
        for (const match of parenthesisMatches) {
          const sizeName = match[1].toUpperCase();
          const quantity = parseInt(match[2]);
          if (quantity > 0 && quantity <= 100) {
            distribution[sizeName] = quantity;
            hasMultipleSizes = true;
            log(`Parenthesis format found: (${sizeName})-${quantity}`);
          }
        }
      }

      // YENI: Tire içeren beden isimleri - "S-M-3" veya "L-XL:2"
      // Önce potansiyel tire içeren beden isimlerini tespit et
      if (!hasMultipleSizes) {
        // "S-M-3" veya "S-M:3" veya "S-M=3" formatları
        const compoundSizePattern = /([A-Z]+-[A-Z]+)\s*[-:=]\s*(\d+)/gi;
        const compoundMatches = [...setContent.matchAll(compoundSizePattern)];

        if (compoundMatches.length > 0) {
          log('Compound size format detected in cart parser');
          for (const match of compoundMatches) {
            const sizeName = match[1].toUpperCase();
            const quantity = parseInt(match[2]);
            if (quantity > 0 && quantity <= 100) {
              distribution[sizeName] = quantity;
              hasMultipleSizes = true;
              log(`Compound size found: ${sizeName}-${quantity}`);
            }
          }
        }
      }

      // Önce "S-2 M-2 L-4 XL-4" veya "44-1 46-2" formatını dene (size-quantity)
      if (!hasMultipleSizes) {
        const sizeQuantityPattern = /([A-Z]{1,4}|\d{2,3})\s*[-:]\s*(\d{1,2})/g;
        let matches = [...setContent.matchAll(sizeQuantityPattern)];

        if (matches.length > 0) {
          log('Size-quantity pattern matched, count:', matches.length);
          matches.forEach(match => {
            const size = match[1].toUpperCase();
            const qty = parseInt(match[2]);
            const isNumericSize = /^\d{2,3}$/.test(size);
            // Harf bedenler: validSizes kontrolü, Numeric bedenler: direkt kabul
            if ((isNumericSize || (validSizes.has(size) && !excludedWords.has(size))) && qty > 0 && qty <= 100) {
              distribution[size] = qty;
              hasMultipleSizes = true;
              log(`Size-quantity found: ${size}-${qty}`);
            }
          });
        }
      }

      // "M1-L1-XL1-XXL1" formatı - beden ve adet arasında ayraç yok
      if (!hasMultipleSizes) {
        const concatParts = setContent.split(/[-\s]+/);
        for (const part of concatParts) {
          const concatMatch = part.match(/^([A-Z]{1,4})(\d{1,2})$/i);
          if (concatMatch) {
            const size = concatMatch[1].toUpperCase();
            const qty = parseInt(concatMatch[2]);
            if ((validSizes.has(size) || /^\d{2,3}$/.test(size)) && !excludedWords.has(size) && qty > 0 && qty <= 100) {
              distribution[size] = qty;
              hasMultipleSizes = true;
              log(`Concat size-qty found: ${size}${qty}`);
            }
          }
        }
      }

      // (toserof) Bitişik rakam-önekli beden formatı - "3XL2-4XL1-5XL1-6XL1" (3XL=size, 2=qty)
      if (!hasMultipleSizes) {
        const dpMatches = [...setContent.matchAll(/(\d+XL)(\d+)/gi)];
        for (const m of dpMatches) {
          const size = m[1].toUpperCase();
          const qty = parseInt(m[2]);
          if (validSizes.has(size) && qty > 0 && qty <= 100) {
            distribution[size] = qty;
            hasMultipleSizes = true;
            log(`Digit-prefixed size found: ${size}${qty}`);
          }
        }
      }

      // Eğer size-quantity pattern çalışmadıysa, "2S-2M-4L-4XL" formatını dene
      if (!hasMultipleSizes) {
        const quantitySizePattern = /(\d+)\s*([A-Z]{1,4})(?=\s|-|$)/g;
        let matches = [...setContent.matchAll(quantitySizePattern)];

        if (matches.length > 0) {
          log('Quantity-size pattern matched, count:', matches.length);
          matches.forEach(match => {
            const qty = parseInt(match[1]);
            const size = match[2].toUpperCase();
            // SADECE geçerli beden isimleri kabul et
            if (validSizes.has(size) && !excludedWords.has(size) && qty > 0 && qty <= 100) {
              distribution[size] = qty;
              hasMultipleSizes = true;
              log(`Quantity-size found: ${qty}${size}`);
            }
          });
        }
      }
      
      if (hasMultipleSizes && Object.keys(distribution).length > 0) {
        // Toplam miktar hesapla
        const totalPerSet = Object.values(distribution).reduce((sum, qty) => sum + qty, 0);

        log('Multi-size set bulundu:', distribution);
        return {
          type: 'multi_size_set',
          distribution: distribution,
          isMultiSize: true,
          totalPerSet: totalPerSet
        };
      }
    }
    
    // 4. PAKET YAPISI FORMATI
    if (cleanText.includes('Paket Yapısı:')) {
      const paketMatch = cleanText.match(/Paket Yapısı:\s*(.+?)(?:Teknik|Kumaş|Barkod|$)/i);
      if (paketMatch) {
        const paketContent = paketMatch[1].trim();
        // '+' ile ayrılmış kısımları say veya sayısal değer bul
        let multiplier = 1;

        // "1S+1M+1L+1XL" gibi formatlar için
        const plusParts = paketContent.split('+').filter(p => p.trim());
        if (plusParts.length > 1) {
          multiplier = plusParts.length;
        } else {
          // Direkt sayı formatı için
          const numMatch = paketContent.match(/(\d+)/);
          if (numMatch) {
            multiplier = parseInt(numMatch[1]);
          }
        }

        log('Paket Yapısı formatı:', multiplier);
        return {
          type: 'paket_yapisi',
          multiplier: multiplier,
          isMultiSize: false
        };
      }
    }

    // 5. STD FORMATI
    // "5xSTANDART", "5xSTD", "STD-5", "STD:5" gibi formatları destekle
    let stdMatch = cleanText.match(/(\d+)\s*x\s*STAN[DA]*R[DT]/i);
    if (!stdMatch) {
      stdMatch = cleanText.match(/STD\s*[-:]\s*(\d+)/);
    }
    if (!stdMatch) {
      stdMatch = cleanText.match(/(\d+)\s*x\s*STD/i);
    }

    if (stdMatch) {
      const multiplier = parseInt(stdMatch[1]);
      log('STD formatı bulundu:', multiplier, 'Pattern:', stdMatch[0]);
      return {
        type: 'std',
        multiplier: multiplier,
        isMultiSize: false
      };
    }

    // 6. ÜRÜN ADINDAN SET BİLGİSİ
    if (productTitle) {
      const titleUpper = productTitle.toUpperCase();
      const setPatterns = [
        /(\d+)\s*[''']?\s*[Ll][İIıi]\s*[Ss][Ee][Tt]/,
        /(\d+)\s*[Aa][Dd][Ee][Tt]/,
        /(\d+)\s*[Ll][İIıi]\s*[Pp][Aa][Kk][Ee][Tt]/
      ];
      
      for (const pattern of setPatterns) {
        const match = titleUpper.match(pattern);
        if (match) {
          const multiplier = parseInt(match[1]);
          if (multiplier > 1) {
            return {
              type: 'title_based',
              multiplier: multiplier,
              isMultiSize: false
            };
          }
        }
      }
    }
    
    return null;
  }
  
  // Ürün bilgilerini al
  async function getProductSetInfo(handle) {
    if (productCache[handle]) {
      return productCache[handle];
    }
    
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return null;
      
      const product = await response.json();
      const setInfo = parseCompleteSetInfo(product.description, product.title);
      
      if (setInfo) {
        setInfo.handle = handle;
        setInfo.productId = product.id;
        setInfo.title = product.title;
        setInfo.variants = product.variants;
        
        productCache[handle] = setInfo;
        log(`Set bilgisi (${handle}):`, setInfo);
      }
      
      return setInfo;
    } catch (error) {
      log('Ürün bilgisi alınamadı:', error);
      return null;
    }
  }
  
  // Sepetteki set ürünlerini grupla
  async function groupSetItems() {
    const cart = await fetch('/cart.js').then(r => r.json());
    setGroups.clear();
    
    for (const item of cart.items) {
      const handle = item.handle || item.url?.split('/products/')[1]?.split('?')[0];
      if (!handle) continue;
      
      const setInfo = await getProductSetInfo(handle);
      if (!setInfo) continue;
      
      // Multi-size set için gruplama
      if (setInfo.isMultiSize) {
        if (!setGroups.has(handle)) {
          // Distribution'ı normalize et - hem 'distribution' hem 'distributions' olabilir
          let normalizedDistribution = {};

          if (setInfo.distribution) {
            normalizedDistribution = setInfo.distribution;
          } else if (setInfo.distributions) {
            // Beden seti formatı - her range'in sizes'ını birleştir
            for (const [range, info] of Object.entries(setInfo.distributions)) {
              if (info.sizes) {
                normalizedDistribution = { ...normalizedDistribution, ...info.sizes };
              }
            }
          }

          setGroups.set(handle, {
            info: setInfo,
            items: [],
            distribution: normalizedDistribution,
            totalPerSet: setInfo.totalPerSet || setInfo.totalPerRange || Object.values(normalizedDistribution).reduce((sum, qty) => sum + qty, 0)
          });
        }

        const group = setGroups.get(handle);

        // Hangi bedene ait olduğunu bul
        const variantTitle = item.variant_title || item.title || '';
        log(`--- Cart item: "${item.product_title}" ---`);
        log(`Variant title: "${variantTitle}"`);
        log(`Quantity: ${item.quantity}`);
        log(`Key: ${item.key}`);

        // Variant title'dan beden çıkar - slash varsa her iki parçayı da kontrol et
        // Çünkü format "RENK / BEDEN" veya "BEDEN / RENK" olabilir
        // Romence'de bedenler "S.", "M." gibi noktayla bitebilir, normalize ediyoruz
        const parts = variantTitle.split('/').map(p => normalizeSize(p));
        log(`Variant parts (normalized):`, parts);

        let sizeKey = null;

        // Önce normalized distribution'dan kontrol et - UZUNDAN KISAYA sırala (tire içeren bedenler önce)
        if (group.distribution && Object.keys(group.distribution).length > 0) {
          const sizes = Object.keys(group.distribution).sort((a, b) => b.length - a.length);
          log(`Checking against distribution (sorted):`, sizes);

          // Her variant part'ı kontrol et
          for (const variantPart of parts) {
            if (sizeKey) break; // Bulunduysa dur

            for (const size of sizes) {
              const normalizedSize = normalizeSize(size);

              // TAM EŞLEŞMEye öncelik ver
              if (variantPart === normalizedSize) {
                sizeKey = size; // Orijinal key'i koru (distribution'da ne ise)
                log(`✓ Size matched from distribution (exact): ${size} from part "${variantPart}"`);
                break;
              }

              // Tire içeren bedenler için kısmi eşleşme: "S-M" içinde "S" var mı?
              if (normalizedSize.includes('-')) {
                const sizeParts = normalizedSize.split('-').map(s => normalizeSize(s));
                if (sizeParts.includes(variantPart)) {
                  sizeKey = size;
                  log(`✓ Size matched from distribution (partial in compound): ${size} contains ${variantPart}`);
                  break;
                }
              }
            }
          }
        }

        // Size option'lardan bul - UZUNDAN KISAYA
        if (!sizeKey) {
          const sizeOptions = ['XXXL', 'XXL', 'XL', 'L', 'M', 'S', 'XS'];
          log(`Checking against size options (sorted):`, sizeOptions);

          // Her variant part'ı kontrol et
          for (const variantPart of parts) {
            if (sizeKey) break; // Bulunduysa dur

            for (const size of sizeOptions) {
              if (variantPart === size || variantPart.startsWith(size + ' ')) {
                sizeKey = size;
                log(`✓ Size matched from options: ${size} from part "${variantPart}"`);
                break;
              }
            }
          }
        }

        if (sizeKey) {
          const expectedQty = group.distribution?.[sizeKey] || 1;
          log(`✓ Adding to group: size=${sizeKey}, expected=${expectedQty}, current=${item.quantity}`);
          group.items.push({
            ...item,
            size: sizeKey,
            expectedQty: expectedQty,
            key: item.key
          });
        } else {
          log(`✗ Size NOT found for variant: "${variantTitle}"`);
        }
      } else {
        // Tek varyantlı set ürünler
        if (!setGroups.has(handle)) {
          setGroups.set(handle, {
            info: setInfo,
            items: [item],
            multiplier: setInfo.multiplier || 1
          });
        }
      }
    }
    
    log('Set grupları oluşturuldu:', setGroups);
    return setGroups;
  }

  // Komple set silme fonksiyonu - YENİ!
  async function removeCompleteSet(itemKey) {
    try {
      // Önce cart'ı al ve set gruplarını güncelle
      const cart = await fetch('/cart.js').then(r => r.json());
      await groupSetItems();
      
      // Bu item'ın hangi set'e ait olduğunu bul
      const cartItem = cart.items.find(item => item.key === itemKey);
      if (!cartItem) return false;
      
      const handle = cartItem.handle || cartItem.url?.split('/products/')[1]?.split('?')[0];
      if (!handle) return false;
      
      const group = setGroups.get(handle);
      if (!group) {
        // Set ürünü değilse normal silme işlemi yap
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: itemKey, quantity: 0 })
        });
        return true;
      }
      
      // Set ürünüyse tüm set'i sil
      isUpdating = true;
      
      const updates = {};
      
      if (group.info.isMultiSize) {
        // Multi-size set: tüm bedenleri sil
        for (const item of group.items) {
          updates[item.key] = 0;
        }
        log(`Multi-size set siliniyor: ${handle}`, Object.keys(updates));
      } else {
        // Tek varyantlı set: sadece o ürünü sil (zaten set olduğu için)
        updates[itemKey] = 0;
        log(`Single-variant set siliniyor: ${handle}`, itemKey);
      }
      
      // Toplu güncelleme yap
      await batchUpdateCart(updates);
      
      // Başarı bildirimi
      const setType = group.info.isMultiSize ? t('setTypeMulti') : t('setTypeSingle');
      showNotification(t('setDeleted', { setType: setType, title: group.info.title }), 'success');

      return true;

    } catch (error) {
      log('Set silme hatası:', error);
      showNotification(t('setDeleteError'), 'warning');
      return false;
    } finally {
      isUpdating = false;
    }
  }

  // Kaldır linklerinden / butonlarından itemKey çıkar
  // (Wonder theme: link.wt-cart__item__remove href="#" - href'te id yok,
  //  parent line-item'da data-line-key var veya hidden input var)
  async function extractItemKeyFromRemoveLink(link) {
    // 1) Link href'inde query string
    const href = link.href || link.getAttribute('href') || '';
    const hrefMatch = href.match(/[?&](?:id|line)=([^&]+)/);
    if (hrefMatch) return decodeURIComponent(hrefMatch[1]);

    // 2) Link'in kendi data-attribute'ları
    if (link.dataset.lineKey) return link.dataset.lineKey;
    if (link.dataset.itemKey) return link.dataset.itemKey;
    if (link.dataset.line) return link.dataset.line;

    // 2.5) (toserof FIX) Wonder: <cart-remove-button data-index="N"> → /cart.js items[N-1].key
    //      Senkron/kesin; fragile varyant-id eşleşmesinden ÖNCE denenir.
    {
      const ceBtn = link.closest('cart-remove-button');
      const idxEl = link.closest('[data-index]');
      const idxRaw = (ceBtn && ceBtn.dataset.index) || link.dataset.index || (idxEl && idxEl.dataset.index);
      const idx = parseInt(idxRaw, 10);
      if (!isNaN(idx) && idx > 0) {
        try {
          const cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
          const it = cart.items[idx - 1];
          if (it && it.key) return it.key;
        } catch (_) { /* ignore */ }
      }
    }

    // 3) Yakındaki cart item element'i (geniş selector)
    const cartItem = link.closest(
      'line-item, [data-cart-item], .cart-item, .cart__item, .line-item, ' +
      '.wt-cart__item, [data-line-key], [data-item-key], tr[data-product-id], tr[data-line-key]'
    );
    if (cartItem) {
      if (cartItem.dataset.lineKey) return cartItem.dataset.lineKey;
      if (cartItem.dataset.itemKey) return cartItem.dataset.itemKey;
      if (cartItem.dataset.line) return cartItem.dataset.line;

      // Hidden / visible quantity input
      const qInput = cartItem.querySelector(
        'input[name*="updates"], input[data-line-key], input[data-quantity-variant-id], ' +
        'input.quantity__input, input.js-counter-quantity'
      );
      if (qInput) {
        // data-line-key
        const lineKey = qInput.dataset.lineKey || qInput.getAttribute('data-line-key');
        if (lineKey) return lineKey;
        // updates[KEY] adından
        const nm = qInput.name || '';
        const nmMatch = nm.match(/updates\[([^\]]+)\]/);
        if (nmMatch) return nmMatch[1];
        // Variant id varsa, /cart.js'den eşleştir
        const variantId = qInput.dataset.quantityVariantId || qInput.getAttribute('data-quantity-variant-id');
        if (variantId) {
          try {
            const cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
            const found = cart.items.find(i =>
              String(i.id) === String(variantId) ||
              String(i.variant_id) === String(variantId)
            );
            if (found) return found.key;
          } catch (_) { /* ignore */ }
        }
      }
    }

    return null;
  }

  // Kaldır linklerini intercept et
  function interceptRemoveLinks() {
    const removeLinks = document.querySelectorAll(
      'a[href*="/cart/change"][href*="quantity=0"], ' +
      'a[aria-label*="kaldır"], a[aria-label*="Kaldır"], ' +
      'a[aria-label*="Remove"], a[aria-label*="remove"], ' +
      'a[aria-label*="Eliminați"], a[aria-label*="eliminați"], ' +
      'a[aria-label*="șters"], a[aria-label*="șter"], ' +
      'button[aria-label*="Remove"], button[aria-label*="remove"], ' +
      'button[aria-label*="kaldır"], button[aria-label*="Kaldır"], ' +
      '.cart-remove, .remove-item, ' +
      '.wt-cart__item__remove, ' +
      'cart-remove-button a, cart-remove-button button'
    );

    removeLinks.forEach(link => {
      if (link.dataset.removeIntercepted) return;
      link.dataset.removeIntercepted = 'true';

      // CAPTURE phase: tema kendi handler'ından önce yakala
      link.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        log('Remove link clicked, looking up itemKey...');
        const itemKey = await extractItemKeyFromRemoveLink(link);

        if (itemKey) {
          log('✓ Remove link → itemKey:', itemKey);
          const success = await removeCompleteSet(itemKey);
          if (success) { await refreshCart(); return; }
          log('removeCompleteSet false → native fallback');
        } else {
          log('✗ itemKey not found → native fallback (toserof)');
        }

        // (toserof FIX) ASLA ÖLÜ BIRAKMA: set yolu başarısız/anahtar yoksa,
        // satırı doğrudan biz sileriz. data-index → /cart.js items[index-1].key
        // → /cart/change qty:0. Eski kod href="#" olduğu için hiçbir şey yapmıyordu.
        try {
          const ceBtn = link.closest('cart-remove-button');
          const idxEl = link.closest('[data-index]');
          const idxRaw = (ceBtn && ceBtn.dataset.index) || link.dataset.index || (idxEl && idxEl.dataset.index);
          const idx = parseInt(idxRaw, 10);
          let keyToRemove = itemKey;
          if (!keyToRemove && !isNaN(idx) && idx > 0) {
            const cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
            keyToRemove = cart.items[idx - 1] && cart.items[idx - 1].key;
          }
          if (keyToRemove) {
            log('native fallback → removing line key:', keyToRemove);
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: keyToRemove, quantity: 0 })
            });
            await refreshCart();
          } else {
            log('native fallback: line key bulunamadı, işlem yapılmadı');
          }
        } catch (err) {
          console.error('[Cart Set] remove fallback error:', err.message || err);
        }
      }, { capture: true });
    });
  }
  
  // Darboğaz stok kontrolü - her beden için max set sayısını hesapla
  async function calculateMaxSets(handle, group) {
    try {
      const cached = productCache[handle];
      const variants = cached && cached.variants ? cached.variants :
        await fetch(`/products/${handle}.js`).then(r => r.json()).then(p => p.variants);

      let maxSets = Infinity;
      let limitingFactor = '';
      let hasInventoryData = false;

      for (const [size, expectedQty] of Object.entries(group.distribution)) {
        if (expectedQty <= 0) continue;

        const normalizedSize = normalizeSize(size);

        const variant = variants ? variants.find(v => {
          const parts = (v.title || '').split('/').map(p => normalizeSize(p));
          if (parts.includes(normalizedSize)) return true;
          if (normalizeSize(v.option1) === normalizedSize) return true;
          if (normalizeSize(v.option2) === normalizedSize) return true;
          if (normalizeSize(v.option3) === normalizedSize) return true;
          return false;
        }) : null;

        if (!variant || !variant.available) {
          maxSets = 0;
          limitingFactor = `${size} (indisponibil)`;
          break;
        }

        if (variant.inventory_quantity !== undefined && variant.inventory_quantity !== null) {
          hasInventoryData = true;
          const possibleSets = Math.floor(variant.inventory_quantity / expectedQty);
          if (possibleSets < maxSets) {
            maxSets = possibleSets;
            limitingFactor = `${size} (stoc: ${variant.inventory_quantity}, necesită: ${expectedQty}/set)`;
          }
        }
      }

      if (!hasInventoryData) maxSets = 99;
      if (maxSets === Infinity) maxSets = 99;

      log(`Max sets for ${handle}: ${maxSets}, limiting: ${limitingFactor}`);
      return { maxSets, limitingFactor };
    } catch (error) {
      log('Stock check error:', error);
      return { maxSets: 99, limitingFactor: '' };
    }
  }

  // Sepete girince otomatik düzeltme - oranları kontrol et ve düzelt
  async function validateAndFixCart() {
    log('=== SMART CART VALIDATION ===');

    for (const [handle, group] of setGroups) {
      if (!group.info.isMultiSize) continue;
      if (group.items.length === 0) continue;

      // Mevcut set sayısını hesapla (en düşük oran)
      let currentSets = Infinity;
      let needsFix = false;

      for (const item of group.items) {
        const itemSets = item.quantity / item.expectedQty;
        currentSets = Math.min(currentSets, Math.floor(itemSets));

        // Oran tam değilse düzeltme gerekli
        if (!Number.isInteger(itemSets)) {
          needsFix = true;
          log(`Ratio broken: ${item.size} has ${item.quantity}, expected multiple of ${item.expectedQty}`);
        }
      }

      if (currentSets === Infinity) currentSets = 0;

      // Tüm bedenler doğru miktarda mı kontrol et
      for (const item of group.items) {
        const expected = currentSets * item.expectedQty;
        if (item.quantity !== expected) {
          needsFix = true;
          log(`Mismatch: ${item.size} has ${item.quantity}, should be ${expected} for ${currentSets} sets`);
        }
      }

      // Eksik bedenler var mı
      const existingSizes = group.items.map(i => i.size);
      const expectedSizes = Object.keys(group.distribution);
      const missingSizes = expectedSizes.filter(s => !existingSizes.includes(s));
      if (missingSizes.length > 0 && currentSets > 0) {
        needsFix = true;
        log(`Missing sizes in cart: ${missingSizes.join(', ')}`);
      }

      if (!needsFix) {
        log(`${handle}: Cart is correct (${currentSets} sets)`);
        continue;
      }

      // Darboğaz stok kontrolü
      const stockCheck = await calculateMaxSets(handle, group);
      const safeSets = Math.min(currentSets, stockCheck.maxSets);

      log(`Fixing ${handle}: ${currentSets} sets → ${safeSets} sets (stock max: ${stockCheck.maxSets})`);

      // Tüm bedenleri düzelt
      await updateMultiSizeSet(handle, safeSets);

      if (safeSets < currentSets) {
        showNotification(t('stockLimitedAdjusted', { title: group.info.title, sets: safeSets, factor: stockCheck.limitingFactor }), 'warning');
      } else {
        const itemsText = Object.entries(group.distribution).map(([size, qty]) => `${size}: ${qty * safeSets}`).join(', ');
        showNotification(t('quantitiesCorrected', { title: group.info.title, sets: safeSets, items: itemsText }), 'info');
      }
    }

    log('=== SMART CART VALIDATION COMPLETE ===');
  }

  // Multi-size set için tüm bedenleri güncelle (stok kontrollü)
  async function updateMultiSizeSet(handle, operation) {
    const group = setGroups.get(handle);
    if (!group || !group.info.isMultiSize) return;

    log('=== UPDATE MULTI-SIZE SET ===');
    log('Handle:', handle);
    log('Operation:', operation);
    log('Group items:', group.items.map(i => `${i.size}:${i.quantity} (expected:${i.expectedQty})`));

    const updates = {};

    // Mevcut set sayısını hesapla
    let currentSets = Infinity;
    for (const item of group.items) {
      const itemSets = Math.floor(item.quantity / item.expectedQty);
      currentSets = Math.min(currentSets, itemSets);
    }
    if (currentSets === Infinity) currentSets = 0;
    log('Current sets:', currentSets);

    // Yeni set sayısını hesapla
    let newSets;
    if (operation === 'increase') {
      newSets = currentSets + 1;
    } else if (operation === 'decrease') {
      newSets = Math.max(0, currentSets - 1);
    } else {
      newSets = Math.max(0, Math.round(operation));
    }

    // Darboğaz stok kontrolü
    if (newSets > 0) {
      const stockCheck = await calculateMaxSets(handle, group);
      if (newSets > stockCheck.maxSets) {
        log(`Stock bottleneck! Requested: ${newSets}, max: ${stockCheck.maxSets}, limiting: ${stockCheck.limitingFactor}`);
        newSets = stockCheck.maxSets;
        showNotification(t('stockLimitedMax', { sets: newSets, factor: stockCheck.limitingFactor }), 'warning');
      }
    }

    log('New sets:', newSets);

    // Her beden için yeni miktarı hesapla
    for (const item of group.items) {
      const newQty = newSets * item.expectedQty;
      updates[item.key] = newQty;
      log(`UPDATE: ${item.size}: ${item.quantity} → ${newQty} (${item.expectedQty} x ${newSets} set)`);
    }

    // Eksik bedenleri kontrol et ve ekle
    if (newSets > 0 && group.distribution) {
      await addMissingVariants(handle, group, newSets);
    }

    // Toplu güncelleme yap
    await batchUpdateCart(updates);

    // Bildirim göster (stok uyarısı zaten gösterildiyse tekrar gösterme)
    if (newSets > 0 || operation === 'decrease') {
      const changeText = operation === 'increase' ? '+1 set' :
                        operation === 'decrease' ? '-1 set' :
                        `${newSets} set`;

      const itemsText = group.items.map(item =>
        `${item.size}: ${item.expectedQty * newSets}`
      ).join(', ');

      showNotification(`${group.info.title}: ${changeText} (${itemsText})`, 'success');
    }
  }
  
  // Eksik varyantları sepete ekle
  async function addMissingVariants(handle, group, sets) {
    if (sets === 0) return;
    
    const existingSizes = group.items.map(item => item.size);
    const missingSizes = Object.keys(group.distribution).filter(size => !existingSizes.includes(size));
    
    if (missingSizes.length === 0) return;
    
    log('Eksik bedenler bulundu:', missingSizes);
    
    try {
      const product = await fetch(`/products/${handle}.js`).then(r => r.json());
      
      for (const size of missingSizes) {
        const normalizedSize = normalizeSize(size);

        // İlgili varyantı bul (case-insensitive + nokta strip + tam eşleşme)
        const variant = product.variants.find(v => {
          if (normalizeSize(v.option1) === normalizedSize) return true;
          if (normalizeSize(v.option2) === normalizedSize) return true;
          if (normalizeSize(v.option3) === normalizedSize) return true;
          // Title fallback: split '/' ile tam eşleşme (substring DEĞİL, çünkü
          // 'S' başka kelimelerin içinde de geçer → false positive olur)
          const titleParts = (v.title || '').split('/').map(p => normalizeSize(p));
          return titleParts.includes(normalizedSize);
        });
        
        if (variant && variant.available) {
          const qty = group.distribution[size] * sets;
          
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variant.id,
              quantity: qty
            })
          });
          
          log(`Eksik beden eklendi: ${size} - ${qty} adet`);
        }
      }
      
      // Grupları yenile
      await groupSetItems();
    } catch (error) {
      log('Eksik varyant ekleme hatası:', error);
    }
  }
  
  // Toplu sepet güncellemesi
  async function batchUpdateCart(updates) {
    if (Object.keys(updates).length === 0) return;
    
    isUpdating = true;
    
    try {
      const formData = new FormData();
      for (const [key, qty] of Object.entries(updates)) {
        formData.append(`updates[${key}]`, qty);
      }
      
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        await refreshCart();
      }
    } catch (error) {
      log('Toplu güncelleme hatası:', error);
    } finally {
      isUpdating = false;
    }
  }
  
  // Sepet kontrollerini ayarla - HEM /cart sayfası HEM cart drawer için
  async function setupCartPageControls() {
    // /cart restriction kaldırıldı: drawer her sayfada açılabilir
    // Cart item bulunamazsa zaten erken çıkar
    const cartItems = document.querySelectorAll('line-item, [data-cart-item], .cart-item, .cart__item, .line-item, .wt-cart__item, tr[data-product-id]');
    if (cartItems.length === 0) return;

    await groupSetItems();

    log(`Cart items found: ${cartItems.length}`);

    for (const item of cartItems) {
      const handle = getHandleFromItem(item);
      log(`Cart item handle: ${handle}`);

      if (!handle) continue;

      const group = setGroups.get(handle);
      log(`Group for ${handle}:`, group);

      if (!group) continue;

      // Multi-size setler için (Beden Seti ve Multi-size distribution)
      if (group.info.isMultiSize) {
        setupMultiSizeControls(item, handle, group);
        addMultiSizeBadge(item, group);
      }
      // Tek varyantlı setler için (STD, Paket Yapısı, Title-based)
      else if (group.info.multiplier && group.info.multiplier > 1) {
        setupSingleVariantControls(item, handle, group);
        const singleTotal = group.items.reduce((s, i) => s + (Number(i.quantity) || 0), 0);
        addSingleVariantBadge(item, group.info.multiplier, singleTotal);
      }
      // Multiplier tanımlı ama 1'e eşit olan durumlar için de kontrol ekle
      else if (group.multiplier && group.multiplier > 1) {
        // group.multiplier kullan (groupSetItems'dan gelen)
        setupSingleVariantControls(item, handle, group);
        const singleTotal = group.items.reduce((s, i) => s + (Number(i.quantity) || 0), 0);
        addSingleVariantBadge(item, group.multiplier, singleTotal);
      }
    }

    // (toserof) Set ürünlerini sepette TEK satıra indir (dağılım rozeti + set toplam fiyat)
    for (const [h, g] of setGroups) {
      if (g && g.info && g.info.isMultiSize) consolidateSetRows(h, g);
    }

    // Kaldır linklerini intercept et - YENİ!
    interceptRemoveLinks();
  }

  // (toserof) Sepette bir multi-size SET'i TEK satıra indir: fazla beden satırlarını gizle,
  // temsilci satırda BEDEN opsiyonunu gizle (dağılım rozeti zaten "Set S×2 M×2 L×2" gösterir, renk kalır),
  // fiyatı set TOPLAMINA çevir. Checkout sunucuda 3 satır olarak DOĞRU kalır; bu yalnız görsel birleştirme.
  function consolidateSetRows(handle, group) {
    try {
      if (!group || !group.info || !group.info.isMultiSize) return;
      if (!group.items || group.items.length < 2) return;

      const allRows = [...document.querySelectorAll('li.cart-item, .cart-item, .wt-cart__item, line-item')];
      const rowByKey = new Map();
      for (const row of allRows) {
        const lk = row.querySelector('[data-line-key]');
        if (lk) rowByKey.set(lk.getAttribute('data-line-key'), row);
      }
      const pairs = [];
      const seenRows = new Set();
      for (const it of group.items) {
        const row = rowByKey.get(it.key);
        if (row && !seenRows.has(row)) { seenRows.add(row); pairs.push({ it, row }); }
      }
      if (pairs.length < 2) return; // tüm set satırları DOM'da değil → dokunma
      pairs.sort((a, b) => (a.row.compareDocumentPosition(b.row) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));

      const primary = pairs[0].row;
      const primaryItem = pairs[0].it;
      const others = pairs.slice(1);

      // 1) fazla beden satırlarını gizle
      others.forEach((o) => { o.row.style.display = 'none'; o.row.dataset.setMerged = 'true'; });

      // 1b) ADET göstergesi: tek bedenin adedi (örn. L:2) yerine SET SAYISINI göster (örn. 1)
      const setCount = Math.max(1, Math.round((Number(primaryItem.quantity) || 0) / (Number(primaryItem.expectedQty) || 1)));
      const qInput = primary.querySelector('input.js-counter-quantity, input[name*="updates"], input[type="number"]');
      if (qInput) {
        qInput.dataset.setCounter = 'true'; // change-handler bunu "set sayısı" olarak yorumlar
        if (String(qInput.value) !== String(setCount)) qInput.value = setCount;
      }

      // 2) temsilci satırda BEDEN opsiyonunu gizle (değeri dağılımdaki bir bedene denk gelen .product-option)
      const distSizes = Object.keys(group.distribution || {}).map((s) => normalizeSize(s));
      primary.querySelectorAll('.product-option').forEach((po) => {
        const valEl = po.querySelector('.value');
        if (!valEl) return; // birim-fiyat .product-option'unda .value yok → dokunma
        const val = normalizeSize(valEl.textContent || '');
        if (val && distSizes.includes(val)) po.style.display = 'none';
      });

      // 3) fiyat: set TOPLAMI (grubun final_line_price toplamı)
      const totalCents = group.items.reduce((s, it) => s + (Number(it.final_line_price) || 0), 0);
      const priceWrap = primary.querySelector('.wt-cart__item__price-wrapper');
      const priceEl = priceWrap && priceWrap.querySelector('span.price--end');
      if (priceEl && totalCents > 0) {
        const formatted = reformatPriceText(priceEl.textContent.trim(), totalCents);
        if (formatted) priceEl.textContent = formatted;
      }

      primary.dataset.setPrimary = 'true';
    } catch (e) {
      console.error('[Cart Set] consolidate error:', e.message || e);
    }
  }

  // Para metninin SAYISINI yenisiyle değiştirir (tema'nın para sembolü/biçimini korur).
  function reformatPriceText(originalText, newAmountCents) {
    try {
      const amount = newAmountCents / 100;
      const dm = originalText.match(/[.,](\d{2})(?!\d)/); // son ondalık ayırıcı
      const decSep = dm ? originalText.charAt(dm.index) : ',';
      const thouSep = decSep === ',' ? '.' : ',';
      let [intPart, decPart] = amount.toFixed(2).split('.');
      intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
      const newNum = intPart + decSep + decPart;
      if (/\d[\d.,\s]*\d|\d/.test(originalText)) return originalText.replace(/\d[\d.,\s]*\d|\d/, newNum);
      return null;
    } catch { return null; }
  }
  
  // Multi-size set kontrolleri
  function setupMultiSizeControls(item, handle, group) {
    // Zaten kurulmuşsa skip et (duplicate önleme)
    if (item.dataset.setControlsAttached === 'true') {
      log(`Multi-size controls already attached, skipping setup for ${handle}`);
      return;
    }

    log(`=== Setup Multi-Size Controls for ${handle} ===`);

    const quantityInput = item.querySelector('input[name*="updates"], input.js-counter-quantity, input.quantity-selector__input, input.quantity__input, input[type="number"]');
    log(`Quantity input found:`, quantityInput !== null);

    if (!quantityInput) {
      log(`⚠️ No quantity input found, skipping`);
      return;
    }

    // Parent row'u bul (table yapısında desktop button'lar başka td'de olabilir)
    const parentRow = item.closest('tr');
    const searchScope = parentRow || item; // Row varsa row'da ara, yoksa item'da
    log(`Search scope:`, parentRow ? 'table row' : 'line-item');

    // Butonları bul - önce input'un container'ından, sonra item'dan
    const quantityContainer = quantityInput.closest('quantity-input, quantity-counter, .quantity-input, .quantity-selector, .quantity, .counter-wrapper, .counter, .cart-item__quantity, .line-item__quantity, [data-quantity]');
    const buttonSearchScope = quantityContainer || searchScope;
    log(`Button search scope:`, quantityContainer ? quantityContainer.tagName + '.' + quantityContainer.className : 'fallback to item');

    // Kapsamlı buton seçici - tema spesifik sınıflar dahil
    const allButtons = buttonSearchScope.querySelectorAll('button, .quantity-selector__button, [name="plus"], [name="minus"], .quantity__button, .js-counter-button, .js-counter-increase, .js-counter-decrease');
    log(`All buttons found: ${allButtons.length}`);

    // Plus ve minus button'ları ayır
    const plusButtons = [];
    const minusButtons = [];

    allButtons.forEach((btn, index) => {
      const ariaLabel = (btn.getAttribute('aria-label') || '').toLowerCase();
      const name = (btn.getAttribute('name') || '').toLowerCase();
      const cls = (btn.className || '').toLowerCase();
      const html = btn.innerHTML || '';
      const text = (btn.textContent || '').trim();

      const isPlus = name === 'plus' ||
        cls.includes('js-counter-increase') || cls.includes('counter-increase') ||
        ariaLabel.includes('increase') || ariaLabel.includes('artır') || ariaLabel.includes('creș') || ariaLabel.includes('add') ||
        html.includes('icon-plus') || html.includes('icon_plus') || html.includes('icon-plus-') ||
        text === '+' || cls.includes('plus');

      const isMinus = name === 'minus' ||
        cls.includes('js-counter-decrease') || cls.includes('counter-decrease') ||
        ariaLabel.includes('decrease') || ariaLabel.includes('azalt') || ariaLabel.includes('reduc') || ariaLabel.includes('subtract') ||
        html.includes('icon-minus') || html.includes('icon_minus') || html.includes('icon-minus-') ||
        text === '-' || text === '−' || cls.includes('minus');

      if (isPlus) plusButtons.push(btn);
      else if (isMinus) minusButtons.push(btn);
    });

    // Fallback: butonlar hala bulunamadıysa, container'daki ilk ve son butonları kullan
    if (plusButtons.length === 0 && minusButtons.length === 0 && allButtons.length >= 2) {
      minusButtons.push(allButtons[0]);
      plusButtons.push(allButtons[allButtons.length - 1]);
      log(`Fallback: using first button as minus, last as plus`);
    }

    log(`Plus buttons: ${plusButtons.length}, Minus buttons: ${minusButtons.length}`);

    // TÜM Plus button'lara handler ekle
    plusButtons.forEach((plusBtn, idx) => {
      if (plusBtn.getAttribute('href')) {
        plusBtn.dataset.originalHref = plusBtn.getAttribute('href');
        plusBtn.setAttribute('href', 'javascript:void(0)');
      }

      plusBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        log(`Plus button ${idx} clicked for multi-size ${handle}`);
        await updateMultiSizeSet(handle, 'increase');
      }, { capture: true });
      log(`✓ Plus button ${idx} handler attached (capture mode)`);
    });

    // TÜM Minus button'lara handler ekle
    minusButtons.forEach((minusBtn, idx) => {
      if (minusBtn.getAttribute('href')) {
        minusBtn.dataset.originalHref = minusBtn.getAttribute('href');
        minusBtn.setAttribute('href', 'javascript:void(0)');
      }

      minusBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        log(`Minus button ${idx} clicked for multi-size ${handle}`);
        await updateMultiSizeSet(handle, 'decrease');
      }, { capture: true });
      log(`✓ Minus button ${idx} handler attached (capture mode)`);
    });

    // Cart item'ı input'tan bul - variant ID veya index üzerinden
    function findCartItemForInput(freshGroup) {
      // 1. data-line-key
      const lineKey = quantityInput.dataset.lineKey || quantityInput.getAttribute('data-line-key');
      if (lineKey) {
        const found = freshGroup.items.find(i => i.key === lineKey);
        if (found) return found;
      }
      // 2. data-quantity-variant-id
      const variantId = quantityInput.dataset.quantityVariantId || quantityInput.getAttribute('data-quantity-variant-id');
      if (variantId) {
        const found = freshGroup.items.find(i => String(i.variant_id) === String(variantId) || String(i.id) === String(variantId));
        if (found) return found;
      }
      // 3. data-index
      const dataIndex = quantityInput.dataset.index || quantityInput.getAttribute('data-index');
      if (dataIndex !== null && dataIndex !== undefined) {
        // Variant title'dan beden çıkar
        const itemEl = quantityInput.closest('line-item, [data-cart-item], .cart-item, .wt-cart__item, .cart__item, .line-item');
        if (itemEl) {
          const sizeEl = itemEl.querySelector('.product-option .value');
          const optionEls = itemEl.querySelectorAll('.product-option .value');
          for (const el of optionEls) {
            const val = (el.textContent || '').trim().toUpperCase();
            const found = freshGroup.items.find(i => i.size === val);
            if (found) return found;
          }
        }
      }
      return null;
    }

    // Input değişikliği - kullanıcı elle rakam girdiğinde set katına yuvarla
    const changeHandler = async (e) => {
      e.stopPropagation();
      e.stopImmediatePropagation();

      await groupSetItems();
      const freshGroup = setGroups.get(handle);
      if (!freshGroup) return;

      const cartItem = findCartItemForInput(freshGroup);

      if (cartItem) {
        const value = parseInt(e.target.value) || 0;
        let sets;
        if (e.target.dataset.setCounter === 'true') {
          // Birleştirilmiş set satırı: input zaten SET SAYISINI gösteriyor
          sets = value < 0 ? 0 : value;
        } else {
          sets = Math.round(value / cartItem.expectedQty);
          if (sets < 0) sets = 0;
          const expectedValue = sets * cartItem.expectedQty;
          if (value !== expectedValue && value > 0) {
            log(`User entered ${value} for ${cartItem.size}, rounding to ${sets} sets (${expectedValue})`);
            showNotification(`${value} → ${expectedValue} (${sets} set)`, 'info');
          }
        }

        log(`Change event: ${cartItem.size} value=${value} → ${sets} sets`);
        await updateMultiSizeSet(handle, sets);
      } else {
        log(`⚠️ Could not find cart item for input, variantId=${quantityInput.dataset.quantityVariantId}, index=${quantityInput.dataset.index}`);
      }
    };
    quantityInput.addEventListener('change', changeHandler, { capture: true });
    quantityInput.addEventListener('input', (e) => {
      // Debounce: kullanıcı yazmayı bitirince change tetiklenecek
      clearTimeout(quantityInput._setDebounce);
      quantityInput._setDebounce = setTimeout(() => {
        changeHandler(e);
      }, 800);
    }, { capture: true });

    // quantity-counter / quantity-input web component'ini intercept et
    const quantityComponent = quantityInput.closest('quantity-input, quantity-counter');
    if (quantityComponent) {
      quantityComponent.onchange = null;

      const form = quantityInput.closest('form');
      // Form submit'i SADECE bir kez handle et (5 beden = 5 setup,
      // her biri ayrı listener eklerse checkout butonu 5 kez bloklanır)
      if (form && !form.dataset.setSubmitInterceptAttached) {
        form.dataset.setSubmitInterceptAttached = 'true';

        // Enter tuşunu blokla (quantity input içinde Enter form submit tetikler).
        // Checkout butonu submit'i ENGELLEMİYORUZ — e.submitter varsa
        // (button click) bırakıyoruz; submitter yoksa (Enter / programatik) blok.
        form.addEventListener('submit', (e) => {
          // Button tıklamasıyla gelen submit'ler (checkout, update vb.) geçsin
          if (e.submitter) {
            return;
          }
          // Submitter yoksa = Enter key veya programatik submit → blokla
          e.preventDefault();
          e.stopImmediatePropagation();
          log('Form submit prevented (no submitter - Enter key or programmatic)');
        }, { capture: true });

        log(`✓ Form submit interceptor attached (allows button-triggered submits)`);
      }

      log(`✓ quantity component intercepted for ${handle}`);
    }

    log(`✓ Multi-size controls setup completed for ${handle}`);
    item.dataset.setControlsAttached = 'true';
  }
  
  // Tek varyantlı set kontrolleri
  function setupSingleVariantControls(item, handle, group) {
    // Zaten kurulmuşsa skip et (duplicate önleme)
    if (item.dataset.setControlsAttached === 'true') {
      log(`Controls already attached, skipping setup for ${handle}`);
      return;
    }

    log(`=== Setup Single Variant Controls for ${handle} ===`);

    const quantityInput = item.querySelector('input[name*="updates"], input.js-counter-quantity, input.quantity-selector__input, input.quantity__input, input[type="number"]');
    log(`Quantity input found:`, quantityInput !== null);

    // Parent row'u bul (table yapısında desktop button'lar başka td'de olabilir)
    const parentRow = item.closest('tr');
    const searchScope = parentRow || item; // Row varsa row'da ara, yoksa item'da
    log(`Search scope:`, parentRow ? 'table row' : 'line-item');

    // Butonları bul - önce input'un container'ından
    const quantityContainer = quantityInput ? quantityInput.closest('quantity-input, quantity-counter, .quantity-input, .quantity-selector, .quantity, .counter-wrapper, .counter, .cart-item__quantity, .line-item__quantity, [data-quantity]') : null;
    const buttonSearchScope = quantityContainer || searchScope;
    log(`Button search scope:`, quantityContainer ? quantityContainer.tagName + '.' + quantityContainer.className : 'fallback to item');

    const allButtons = buttonSearchScope.querySelectorAll('button, .quantity-selector__button, [name="plus"], [name="minus"], .quantity__button, .js-counter-button, .js-counter-increase, .js-counter-decrease');
    log(`All buttons found: ${allButtons.length}`);

    const plusButtons = [];
    const minusButtons = [];

    allButtons.forEach((btn, index) => {
      const ariaLabel = (btn.getAttribute('aria-label') || '').toLowerCase();
      const name = (btn.getAttribute('name') || '').toLowerCase();
      const cls = (btn.className || '').toLowerCase();
      const html = btn.innerHTML || '';
      const text = (btn.textContent || '').trim();

      const isPlus = name === 'plus' ||
        cls.includes('js-counter-increase') || cls.includes('counter-increase') ||
        ariaLabel.includes('increase') || ariaLabel.includes('artır') || ariaLabel.includes('creș') || ariaLabel.includes('add') ||
        html.includes('icon-plus') || html.includes('icon_plus') || html.includes('icon-plus-') ||
        text === '+' || cls.includes('plus');

      const isMinus = name === 'minus' ||
        cls.includes('js-counter-decrease') || cls.includes('counter-decrease') ||
        ariaLabel.includes('decrease') || ariaLabel.includes('azalt') || ariaLabel.includes('reduc') || ariaLabel.includes('subtract') ||
        html.includes('icon-minus') || html.includes('icon_minus') || html.includes('icon-minus-') ||
        text === '-' || text === '−' || cls.includes('minus');

      if (isPlus) plusButtons.push(btn);
      else if (isMinus) minusButtons.push(btn);
    });

    if (plusButtons.length === 0 && minusButtons.length === 0 && allButtons.length >= 2) {
      minusButtons.push(allButtons[0]);
      plusButtons.push(allButtons[allButtons.length - 1]);
      log(`Fallback: using first button as minus, last as plus`);
    }

    log(`Plus buttons: ${plusButtons.length}, Minus buttons: ${minusButtons.length}`);

    if (!quantityInput) {
      log(`⚠️ No quantity input found, skipping`);
      return;
    }

    // Multiplier'ı güvenli şekilde al - group.info.multiplier veya group.multiplier
    const multiplier = group.info.multiplier || group.multiplier || 1;

    // Eğer multiplier 1 ise, set ürünü değildir, kontrol eklemeye gerek yok
    if (multiplier <= 1) {
      log(`Multiplier is 1, skipping set controls`);
      return;
    }

    log(`✓ Setting up controls with multiplier: ${multiplier}`);

    // Mevcut değeri düzelt
    const currentQty = parseInt(quantityInput.value) || 0;
    const roundedQty = Math.round(currentQty / multiplier) * multiplier;

    if (currentQty !== roundedQty && roundedQty > 0) {
      quantityInput.value = roundedQty;
      updateSingleItem(quantityInput.name, roundedQty);
      log(`Quantity adjusted: ${currentQty} → ${roundedQty}`);
    }

    // TÜM Plus button'lara handler ekle (mobile + desktop)
    plusButtons.forEach((plusBtn, idx) => {
      // href'i disable et (sayfayı yönlendirmemesi için)
      if (plusBtn.getAttribute('href')) {
        plusBtn.dataset.originalHref = plusBtn.getAttribute('href');
        plusBtn.setAttribute('href', 'javascript:void(0)');
        log(`Plus button ${idx} href disabled`);
      }

      plusBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Diğer handler'ları durdur!
        log(`Plus button clicked for ${handle}`);
        const current = parseInt(quantityInput.value) || 0;
        const newValue = current + multiplier;
        quantityInput.value = newValue;

        // Line key'i input'tan al (data-line-key attribute'u)
        const lineKey = quantityInput.dataset.lineKey || quantityInput.getAttribute('data-line-key');
        log(`Updating with line key: ${lineKey}, new value: ${newValue}`);
        await updateSingleItem(lineKey, newValue);
        showNotification(t('setAdded', { qty: multiplier }), 'success');
      }, { capture: true }); // CAPTURE PHASE - erken yakala!
      log(`✓ Plus button ${idx} handler attached (capture mode)`);
    });

    if (plusButtons.length === 0) {
      log(`⚠️ No plus buttons found`);
    }

    // TÜM Minus button'lara handler ekle (mobile + desktop)
    minusButtons.forEach((minusBtn, idx) => {
      // href'i disable et
      if (minusBtn.getAttribute('href')) {
        minusBtn.dataset.originalHref = minusBtn.getAttribute('href');
        minusBtn.setAttribute('href', 'javascript:void(0)');
        log(`Minus button ${idx} href disabled`);
      }

      minusBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Diğer handler'ları durdur!
        log(`Minus button clicked for ${handle}`);
        const current = parseInt(quantityInput.value) || 0;
        const newValue = Math.max(0, current - multiplier);
        quantityInput.value = newValue;

        // Line key'i input'tan al (data-line-key attribute'u)
        const lineKey = quantityInput.dataset.lineKey || quantityInput.getAttribute('data-line-key');
        log(`Updating with line key: ${lineKey}, new value: ${newValue}`);
        await updateSingleItem(lineKey, newValue);
        if (newValue > 0) {
          showNotification(t('setRemoved', { qty: multiplier }), 'info');
        }
      }, { capture: true }); // CAPTURE PHASE - erken yakala!
      log(`✓ Minus button ${idx} handler attached (capture mode)`);
    });

    if (minusButtons.length === 0) {
      log(`⚠️ No minus buttons found`);
    }

    // İşlem tamamlandı, flag'i set et
    item.dataset.setControlsAttached = 'true';
    log(`✓ Controls setup completed for ${handle}`);
  }
  
  // Tek item güncelleme
  async function updateSingleItem(key, quantity) {
    // Eğer key "updates[...]" formatındaysa temizle
    // Değilse direkt lineKey olarak kullan (data-line-key'den gelen format)
    let lineKey = key;
    if (key && key.includes('updates[')) {
      lineKey = key.replace('updates[', '').replace(']', '');
    }

    log(`updateSingleItem: lineKey=${lineKey}, quantity=${quantity}`);
    const updates = { [lineKey]: quantity };
    await batchUpdateCart(updates);
  }
  
  // Badge yerleştirme - Wonder teması uyumlu
  function insertBadge(item, badge) {
    const optionDiv = item.querySelector('.product-option, .options, .cart-item__details, .wt-cart__item__data');
    if (optionDiv) {
      optionDiv.insertBefore(badge, optionDiv.firstChild);
      log(`✓ Badge inserted into product options`);
      return;
    }
    const priceEl = item.querySelector('price-list, .price-list, sale-price, .price, .cart-item__price, .line-item__price, .wt-cart__item__price-wrapper');
    if (priceEl) {
      priceEl.parentNode.insertBefore(badge, priceEl);
      log(`✓ Badge inserted before price`);
      return;
    }
    item.appendChild(badge);
    log(`✓ Badge appended to item`);
  }

  // Multi-size badge
  function addMultiSizeBadge(item, group) {
    if (item.querySelector('.multi-size-badge')) return;

    const badge = document.createElement('div');
    badge.className = 'multi-size-badge';
    badge.style.cssText = `
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 4px 10px;
      margin: 4px 0;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      font-size: 11px;
      color: #555;
      background: #fafafa;
      line-height: 1.4;
    `;

    const parts = group.items.map(i => `<span style="font-weight:600;">${i.size}</span><span style="color:#999;">&times;${i.expectedQty}</span>`);

    // Toplam adet = set satırlarındaki gerçek miktarların toplamı (setCount × set başına parça)
    const totalQty = group.items.reduce((s, i) => s + (Number(i.quantity) || 0), 0);

    badge.innerHTML = `
      <span style="color:#888;">Set</span>
      <span style="display:inline-flex;gap:6px;">${parts.join('<span style="color:#ddd;">|</span>')}</span>
      <span style="color:#ddd;">|</span>
      <span style="color:#888;">${t('totalLabel')}</span>
      <span style="font-weight:700;color:#333;">${totalQty} ${t('pieceUnit')}</span>
    `;

    insertBadge(item, badge);
  }

  // Tek varyant badge
  function addSingleVariantBadge(item, multiplier, totalQty) {
    if (item.querySelector('.single-variant-badge')) {
      log(`Badge already exists, skipping`);
      return;
    }

    log(`Adding badge for multiplier: ${multiplier}`);

    const badge = document.createElement('div');
    badge.className = 'single-variant-badge';
    badge.style.cssText = `
      display: inline-flex;
      align-items: center;
      gap: 5px;
      padding: 4px 10px;
      margin: 4px 0;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      font-size: 11px;
      color: #555;
      background: #fafafa;
      line-height: 1.4;
    `;

    badge.innerHTML = `
      <span style="color:#888;">Set</span>
      <span style="font-weight:600;">&times;${multiplier}</span>
      ${(Number(totalQty) > 0) ? `
      <span style="color:#ddd;">|</span>
      <span style="color:#888;">${t('totalLabel')}</span>
      <span style="font-weight:700;color:#333;">${totalQty} ${t('pieceUnit')}</span>` : ''}
    `;

    insertBadge(item, badge);
  }
  
  // Handle'ı al
  function getHandleFromItem(item) {
    const link = item.querySelector('a[href*="/products/"]');
    if (link) {
      const url = link.href || link.getAttribute('href');
      const match = url.match(/\/products\/([^?#]+)/);
      if (match) return match[1];
    }
    return null;
  }
  
  // Sepeti yenile
  async function refreshCart() {
    try {
      const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.refresh === 'function') {
          cartDrawer.refresh();
        } else if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }

      // NOT: /cart sayfası için otomatik reload KALDIRILDI —
      // sonsuz döngüye sebep oluyordu (refreshCart → reload → init →
      // validateAndFixCart → fix → batchUpdateCart → refreshCart → ...).
      // Bunun yerine cart:updated event'i dispatch ediyoruz, tema kendi
      // güncellemesini yapsın. Kullanıcı manuel olarak da F5 yapabilir.
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      const response = await fetch('/cart.js', { cache: 'no-store' });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const cart = await response.json();

      if (cart && cart.item_count !== undefined) {
        const itemCount = cart.item_count || 0;
        document.querySelectorAll('.cart-count, [data-cart-count]').forEach(el => {
          if (el && el.textContent !== undefined) {
            el.textContent = itemCount;
          }
        });
      }

      // (toserof FIX) /cart SAYFASINI gerçekten yeniden çiz.
      // Eski kod yalnız drawer'ı yeniliyor + tema'nın dinlemediği event atıyordu →
      // /cart sayfasında silinen ürünler ekranda kalıyordu (bayat DOM) → ölü buton.
      // Wonder cart.js onCartUpdate ile aynı yöntem: section HTML çek + .js-contents değiştir.
      const cartPageEl = document.querySelector('cart-items.cart-page') || document.getElementById('main-cart-items');
      if (cartPageEl) {
        const empty = !cart || cart.item_count === 0;
        const sectionsToRender = [
          { id: 'main-cart-items', selector: '.js-contents' },
          { id: 'main-cart-footer', selector: '.js-contents' }
        ];
        for (const s of sectionsToRender) {
          const container = document.getElementById(s.id);
          if (!container) continue;
          const sectionId = container.dataset.id || s.id;
          try {
            const r = await fetch(`/cart?section_id=${encodeURIComponent(sectionId)}`, { cache: 'no-store' });
            const text = await r.text();
            const parsed = new DOMParser().parseFromString(text, 'text/html');
            const src = parsed.querySelector(s.selector);
            const dest = container.querySelector(s.selector);
            if (src && dest) dest.innerHTML = src.innerHTML;
          } catch (_) { /* sessiz */ }
        }
        const itemsEl = document.querySelector('cart-items.cart-page, cart-items');
        if (itemsEl) itemsEl.classList.toggle('is-empty', empty);
        const footerEl = document.getElementById('main-cart-footer');
        if (footerEl) footerEl.classList.toggle('is-empty', empty);
        // Yenilenen DOM'a set kontrollerini + remove handler'larını tekrar bağla
        if (typeof setupCartPageControls === 'function') {
          try { await setupCartPageControls(); } catch (_) { /* sessiz */ }
        }
      }
    } catch (error) {
      console.error('[Cart Set] Error refreshing cart:', error.message || error);
    }
  }
  
  // Mini sepet interceptor - Shopify native isteklerini yakalayıp set olarak güncelle
  function interceptMiniCart() {
    const originalFetch = window.fetch;

    window.fetch = async function(url, options = {}) {
      // /cart/clear ve diğer set-irrelevant istekleri yakalama
      const isCartMutation = typeof url === 'string' &&
        (url.includes('/cart/change') || url.includes('/cart/update'));

      if (isCartMutation && !isUpdating) {

        try {
          const body = options.body;
          let lineKey;
          let requestedQty;

          // 1) FormData
          if (body instanceof FormData) {
            lineKey = body.get('id') || body.get('line');
            const q = body.get('quantity');
            if (q !== null) requestedQty = parseInt(q);
          }
          // 2) String body - JSON ya da URL-encoded
          else if (typeof body === 'string' && body.length > 0) {
            // Önce JSON dene
            let parsed = null;
            try {
              parsed = JSON.parse(body);
            } catch (_) {
              parsed = null;
            }
            if (parsed && typeof parsed === 'object') {
              lineKey = parsed.id || parsed.line;
              if (parsed.quantity !== undefined) requestedQty = parseInt(parsed.quantity);
            } else {
              // URL-encoded fallback: "id=X&quantity=0"
              try {
                const params = new URLSearchParams(body);
                lineKey = params.get('id') || params.get('line');
                const q = params.get('quantity');
                if (q !== null) requestedQty = parseInt(q);
              } catch (_) { /* ignore */ }
            }
          }
          // 3) URLSearchParams direkt
          else if (body instanceof URLSearchParams) {
            lineKey = body.get('id') || body.get('line');
            const q = body.get('quantity');
            if (q !== null) requestedQty = parseInt(q);
          }

          // 4) URL query string fallback (örn: /cart/change.js?id=X&quantity=0)
          if (!lineKey) {
            const idMatch = url.match(/[?&](?:id|line)=([^&]+)/);
            if (idMatch) lineKey = decodeURIComponent(idMatch[1]);
          }
          if (requestedQty === undefined || requestedQty === null || isNaN(requestedQty)) {
            const qtyMatch = url.match(/[?&]quantity=(\d+)/);
            if (qtyMatch) requestedQty = parseInt(qtyMatch[1]);
          }

          if (!lineKey || requestedQty === undefined || isNaN(requestedQty)) {
            return originalFetch.call(this, url, options);
          }

          // Bu item bir set ürününe ait mi kontrol et
          const cart = await originalFetch('/cart.js').then(r => r.json());
          const cartItem = cart.items.find(i => i.key === lineKey);

          if (cartItem) {
            const handle = cartItem.handle;
            await groupSetItems();

            const group = setGroups.get(handle);
            if (group && group.info.isMultiSize) {
              const currentItem = group.items.find(i => i.key === lineKey);
              if (currentItem) {
                // Kullanıcının girdiği değerden set sayısını hesapla
                const newSets = Math.max(0, Math.round(requestedQty / currentItem.expectedQty));
                log(`Fetch intercept: ${currentItem.size} requested=${requestedQty}, expectedQty=${currentItem.expectedQty} → ${newSets} sets`);

                await updateMultiSizeSet(handle, newSets);

                // Fake success dön - gerçek güncellemeyi updateMultiSizeSet yaptı
                const updatedCart = await originalFetch('/cart.js').then(r => r.json());
                return new Response(JSON.stringify(updatedCart), {
                  status: 200,
                  headers: { 'Content-Type': 'application/json' }
                });
              }
            }

            // Tek varyantlı set kontrolü
            if (group && !group.info.isMultiSize) {
              const multiplier = group.info.multiplier || group.multiplier || 1;
              if (multiplier > 1) {
                // Set katına yuvarla
                const roundedQty = Math.round(requestedQty / multiplier) * multiplier;
                if (roundedQty !== requestedQty) {
                  log(`Single-variant set: rounding ${requestedQty} → ${roundedQty} (multiplier: ${multiplier})`);

                  // Doğru miktarla güncelle
                  const correctedBody = JSON.stringify({ id: lineKey, quantity: roundedQty });
                  return originalFetch.call(this, url, {
                    ...options,
                    body: correctedBody,
                    headers: { 'Content-Type': 'application/json' }
                  });
                }
              }
            }
          }
        } catch (error) {
          log('Fetch intercept error:', error);
        }
      }

      return originalFetch.call(this, url, options);
    };
  }
  
  // Bildirim
  function showNotification(message, type = 'info') {
    const existing = document.querySelector('.cart-set-notification');
    if (existing) existing.remove();
    
    const colors = {
      success: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      info: 'linear-gradient(135deg, #36D1DC 0%, #5B86E5 100%)',
      warning: 'linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)'
    };
    
    const notification = document.createElement('div');
    notification.className = 'cart-set-notification';
    notification.style.cssText = `
      position: fixed;
      bottom: 30px;
      right: 30px;
      background: ${colors[type]};
      color: white;
      padding: 16px 24px;
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0,0,0,0.2);
      z-index: 99999;
      animation: slideInBounce 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
      font-size: 14px;
      font-weight: 500;
      max-width: 400px;
      display: flex;
      align-items: center;
      gap: 12px;
    `;
    
    const icons = {
      success: '✓',
      info: 'ℹ',
      warning: '⚠'
    };
    
    notification.innerHTML = `
      <span style="font-size: 20px; font-weight: bold;">${icons[type]}</span>
      <span>${message}</span>
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.style.animation = 'slideOutBounce 0.4s ease-in';
      setTimeout(() => notification.remove(), 400);
    }, 3500);
  }
  
  // CSS
  function addStyles() {
    if (document.querySelector('#cart-set-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'cart-set-styles';
    style.textContent = `
      @keyframes slideInBounce {
        0% { 
          transform: translateX(120%) scale(0.8);
          opacity: 0;
        }
        60% {
          transform: translateX(-10%) scale(1.02);
          opacity: 1;
        }
        100% { 
          transform: translateX(0) scale(1);
          opacity: 1;
        }
      }
      @keyframes slideOutBounce {
        from { 
          transform: translateX(0) scale(1);
          opacity: 1;
        }
        to { 
          transform: translateX(120%) scale(0.8);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);
  }
  
  // Event listeners
  function addEventListeners() {
    document.addEventListener('cart:refresh', () => {
      setTimeout(setupCartPageControls, 500);
    });
    
    document.addEventListener('cart:updated', () => {
      setTimeout(setupCartPageControls, 500);
    });
  }
  
  // DOM observer - drawer + /cart için, cart item değişikliklerinde debounced çalışır
  const CART_ITEM_SELECTOR = 'line-item, [data-cart-item], .cart-item, .cart__item, .line-item, .wt-cart__item, tr[data-product-id]';
  function observeChanges() {
    let debounceTimer = null;

    const observer = new MutationObserver((mutations) => {
      // Sadece cart-relevant eklenmiş/kaldırılmış node varsa tetikle
      let cartRelated = false;
      for (const m of mutations) {
        const nodes = [...m.addedNodes, ...m.removedNodes];
        for (const node of nodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.(CART_ITEM_SELECTOR) ||
              node.querySelector?.(CART_ITEM_SELECTOR)) {
            cartRelated = true;
            break;
          }
        }
        if (cartRelated) break;
      }

      if (!cartRelated) return;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        setupCartPageControls();
      }, 250);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Ana başlatma
  async function init() {
    log('Cart Set Multiplier başlatılıyor...');
    
    addStyles();
    interceptMiniCart();
    await setupCartPageControls();

    // Sepete girince otomatik düzeltme
    if (window.location.pathname.includes('/cart')) {
      await validateAndFixCart();
    }

    addEventListeners();
    observeChanges();

    log('Hazır! Set grupları:', setGroups);
  }
  
  // DOM hazır olduğunda başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();